import React from 'react'

export default p => (
  <div className="p16">
    <h1>Introduction</h1>
    <div className="ui divider"></div>
    <i>Vancouver Table Tennis Club</i> (VTTC) is one of the best table tennis
    club in the Greater Vancouver area. The Club offers high quality
    tournament-level tables in a comfortable, well-lit playing environment.
    <br />
    <br />
    <b>VTTC offers a wide variety of services, including:</b>
    <ul>
      <li>Leisure Playing</li>

      <li>Training Lessons (Groups or Individuals)</li>

      <li>Table Reservations for Leisure, Training, or Tournament Uses</li>

      <li>Tournaments</li>

      <li>Professional Table Tennis Accessories</li>

      <li>Dancing studio rental</li>

      <li>Family and group party, meeting, and teaching</li>
    </ul>
    <br />
    <b>VTTC also features:</b>
    <ul>
      <li>5500 sq/ft playing area</li>

      <li>10 ITTF approved international tournament-level tables</li>

      <li>Changing rooms and lockers</li>

      <li>Drinks and Snacks bar</li>
    </ul>
    <br />
    <b>We Provide:</b>
    <ul>
      <li>Drop-in</li>

      <li>Discounted Package (11 Drop-Ins)</li>

      <li>Monthly pass</li>

      <li>Annual pass</li>

      <li>Senior Monthly Pass (Tue/Thu 1pm-6pm) (Mon/Wed/Fri 1pm-3:30pm)</li>

      <li>Group buy or tournament</li>

      <li>Racket rental</li>

      <li>Ball rental</li>

      <li>Training class: Beginner & Advanced</li>

      <li>Private lesson</li>

      <li>Lockers rental</li>

      <li>Table Rental</li>

      <li>
        Cancellation for private lessons and group training lessons must be made
        24 hours in advance, otherwise there will be no refund. All passes and
        packages are valid 1 year from date of issue.
      </li>
    </ul>
  </div>
)
